"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarProvider = exports.createMuiTheme = exports.ThemeProvider = exports.Utils = exports.UI = exports.HOC = exports.Stateful = exports.Data = exports.CrudSimple = exports.Auth = void 0;

var notistack_1 = require("notistack");

Object.defineProperty(exports, "SnackbarProvider", {
  enumerable: true,
  get: function get() {
    return notistack_1.SnackbarProvider;
  }
});

var ThemeProvider_1 = __importDefault(require("@material-ui/styles/ThemeProvider"));

exports.ThemeProvider = ThemeProvider_1.default;

var createMuiTheme_1 = __importDefault(require("@material-ui/core/styles/createMuiTheme"));

exports.createMuiTheme = createMuiTheme_1.default;

var Auth = __importStar(require("./auth"));

exports.Auth = Auth;

var CrudSimple = __importStar(require("./crud-simple"));

exports.CrudSimple = CrudSimple;

var Data = __importStar(require("./data"));

exports.Data = Data;

var Stateful = __importStar(require("./stateful"));

exports.Stateful = Stateful;

var HOC = __importStar(require("./hoc"));

exports.HOC = HOC;

var UI = __importStar(require("./ui"));

exports.UI = UI;

var Utils = __importStar(require("./utils"));

exports.Utils = Utils;